import { useAppAction, useAppSelector } from "./redux";
import {
  getExtraSpec,
  getStyleEditorViewSelector,
  setExtraSpec,
  setStyleEditorView,
} from "../reducers/styleReducer";

export const useStyleEditorView = () => {
  return useAppSelector(getStyleEditorViewSelector);
};

export const useExtraPartialSpec = () => {
  return useAppSelector(getExtraSpec);
};

export const useSetExtraSpec = () => {
  return useAppAction(setExtraSpec);
};

export const useSetStyleEditorView = () => {
  return useAppAction(setStyleEditorView);
};
